<template>
  <!-- 제목과 폼 -->
  <div class="page_title">약관동의</div>
  <div>
    <form @submit.prevent="confirmStep()">
      <div class="terms_area">
        <div class="all_ch">
          <input id="check_all" type="checkbox" @change="checkAll" />
          <label for="check_all" class="box"></label>
          <label for="check_all" class="check_all">
            <p>전체동의</p>
            <span>필수 및 선택 정보를 한번에 동의하실 수 있습니다.</span>
          </label>
        </div>

        <!-- 약관 동의 체크박스 및 팝업 -->
        <div class="ch_box">
          <input
            id="termsofuse"
            type="checkbox"
            name="agree"
            value="termsofuse"
            v-model="termsOfUse"
          />
          <label for="termsofuse"></label>
          <label for="termsofuse" class="termsofuse ch_title">
            (필수) 라온 메타데미 이용약관
          </label>
          <button
            class="showTerms"
            type="button"
            @click="openTermsPopup('termsOfUse')"
          >
            약관 보기
          </button>

          <!-- 팝업 -->
          <div
            v-if="isTermsOfUseVisible"
            class="terms_overlay"
            @click="closeTermsPopup('termsOfUse')"
          >
            <div class="terms_popup" @click.stop>
              <div class="terms_content">
                <termsInner />
              </div>
              <button
                class="close_btn"
                type="button"
                @click="closeTermsPopup('termsOfUse')"
              >
                닫기
              </button>
            </div>
          </div>
        </div>

        <!-- 개인정보 동의 체크박스 -->
        <div class="ch_box">
          <input
            id="privacy"
            type="checkbox"
            name="agree"
            value="privacy"
            v-model="privacy"
          />
          <label for="privacy"></label>
          <label for="privacy" class="privacy ch_title">
            (필수) 개인정보 수집 및 이용 동의
          </label>
          <button
            class="showTerms"
            type="button"
            @click="openTermsPopup('privacy')"
          >
            약관 보기
          </button>
          <div
            v-if="isPrivacyVisible"
            class="terms_overlay"
            @click="closeTermsPopup('privacy')"
          >
            <div class="terms_popup tables" @click.stop>
              <div class="terms_content_tables">
                <privacyText />
              </div>
              <button
                class="close_btn tables"
                type="button"
                @click="closeTermsPopup('privacy')"
              >
                닫기
              </button>
            </div>
          </div>
        </div>
        <!-- <div class="terms">
          <privacyText />
        </div> -->

        <!-- 마케팅 동의 체크박스 -->
        <div class="ch_box">
          <input
            id="marketing"
            v-model="marketing"
            type="checkbox"
            name="agree"
            value="marketing"
          />
          <label for="marketing"></label>
          <label for="marketing" class="marketing ch_title">
            (선택) 마케팅 정보 수신 동의
          </label>
          <button
            class="showTerms"
            type="button"
            @click="openTermsPopup('marketing')"
          >
            약관 보기
          </button>
          <div
            v-if="isMarketingVisible"
            class="terms_overlay"
            @click="closeTermsPopup('marketing')"
          >
            <div class="terms_popup tables" @click.stop>
              <div class="terms_content_tables">
                <marketingText />
              </div>
              <button
                class="close_btn tables"
                type="button"
                @click="closeTermsPopup('marketing')"
              >
                닫기
              </button>
            </div>
          </div>
        </div>
        <!-- <div class="terms">
          <marketingText />
        </div> -->

        <!-- 확인 버튼 -->
        <div class="btn_area">
          <input
            type="button"
            class="btn_basic"
            value="동의"
            @click="confirmStep"
          />
        </div>
      </div>
    </form>
  </div>
  <div>
    <ModalAlertAgree
      :alertMsg="errMsg"
      :isOpen="errStatus"
      @update:isOpen="updateStatus"
    />
  </div>
</template>

<script>
import { ref } from 'vue'
import termsInner from '../agree/termsInner.vue'
import privacyText from '../agree/privacyText.vue'
import marketingText from '../agree/marketingText.vue'
import ModalAlertAgree from './ModalAlertAgree.vue'

export default {
  name: 'JoinStepOne',
  components: {
    termsInner,
    privacyText,
    marketingText,
    ModalAlertAgree,
  },
  emits: ['nextStep'],
  setup(props, { emit }) {
    const errMsg = ref('')
    const errStatus = ref(false)
    const updateStatus = () => {
      errStatus.value = false
    }
    const isTermsOfUseVisible = ref(false)
    const isPrivacyVisible = ref(false)
    const isMarketingVisible = ref(false)

    const termsOfUse = ref(false)
    const privacy = ref(false)
    const marketing = ref(false)

    const confirmStep = () => {
      if (!termsOfUse.value || !privacy.value) {
        errMsg.value = '필수 항목에 동의해 주셔야 합니다.'
        errStatus.value = true
      } else {
        localStorage.setItem('marketing', marketing.value ? 'true' : 'false')
        emit('nextStep')
      }
    }

    const checkAll = (event) => {
      const isChecked = event.target.checked
      termsOfUse.value = isChecked
      privacy.value = isChecked
      marketing.value = isChecked
    }

    const openTermsPopup = (type) => {
      if (type === 'termsOfUse') {
        isTermsOfUseVisible.value = true
      } else if (type === 'privacy') {
        isPrivacyVisible.value = true
      } else if (type === 'marketing') {
        isMarketingVisible.value = true
      }
    }

    const closeTermsPopup = (type) => {
      if (type === 'termsOfUse') {
        isTermsOfUseVisible.value = false
      } else if (type === 'privacy') {
        isPrivacyVisible.value = false
      } else if (type === 'marketing') {
        isMarketingVisible.value = false
      }
    }

    return {
      errMsg,
      errStatus,
      updateStatus,

      termsOfUse,
      privacy,
      marketing,
      confirmStep,
      checkAll,
      openTermsPopup,
      closeTermsPopup,

      isTermsOfUseVisible,
      isPrivacyVisible,
      isMarketingVisible,
    }
  },
}
</script>

<style>
.all_ch {
  padding: 0 70px; /* 컨테이너의 패딩 추가 */
}

.terms_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.terms_popup {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  max-width: 800px;
  width: 100%;
  height: 55%;
  z-index: 1001;
}
/* 줄글만 있는 경우 */
.terms_content {
  max-height: 47vh; /* 팝업 내부의 내용 높이 제한 */
  overflow-y: auto; /* 내용이 넘칠 경우 스크롤 */
}

.terms_popup.tables {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  max-width: 800px;
  width: 100%;
  height: 55%;
  z-index: 1001;
}
/* 표로 짧게 있는 경우 */
.terms_content_tables {
  max-height: 34vh;
}
/* .showTerms {
  margin-left: 120px;
} */

.close_btn {
  float: right;
  margin-right: -2px;
  margin-top: 5px;
}
.close_btn.tables {
  float: right;
  margin-right: -2px;
  margin-top: 125px;
}

.ch_box {
  display: flex;
  align-items: center; /* 수직 정렬 */
  margin-bottom: 10px; /* 항목 간의 여백 */
  padding: 0 70px; /* 컨테이너의 패딩 추가 */
  justify-content: space-between; /* 자식 요소들 사이의 공간 분배 */
}

.ch_box input[type='checkbox'] {
  margin-right: 10px; /* 체크박스와 텍스트 간의 여백 */
}

.ch_box .ch_title {
  flex: 1; /* 제목 영역이 가능한 공간을 차지하도록 설정 */
}

.showTerms {
  margin-left: 20px; /* 버튼과 제목 간의 여백 */
}
</style>
